import { render, staticRenderFns } from "./SlideWrapper.vue?vue&type=template&id=1181b7d8&scoped=true"
import script from "./SlideWrapper.vue?vue&type=script&lang=js"
export * from "./SlideWrapper.vue?vue&type=script&lang=js"
import style0 from "./SlideWrapper.vue?vue&type=style&index=0&id=1181b7d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181b7d8",
  null
  
)

export default component.exports